export default __webpack_public_path__ + "static/media/new-earn-icon.3749063a.png";